import { AttentionPlace, defaultAttentionPlace, defaultMedicalSpeciality, MedicalSpeciality, UserAllowedToPrescript } from "../../interface/interface"
import { defaultComboCostDTO } from "../ComboCostDTO";
import { ComboDataDTO, defaultComboDataDTO } from "../ComboDataDTO"

export interface PersonalData {
    firstname: string,
    lastname: string,
    document: string,
    documenttype: ComboDataDTO | null,
    gender: string,
    birthdate: Date | null,
    address: string,
    city: ComboDataDTO | null,
    isCityExternalId: boolean,
    mobilephone: string,
    email: string,
}

export const defaultPersonalData: PersonalData = {
    firstname: '',
    lastname: '',
    document: '',
    documenttype: defaultComboDataDTO,
    gender: 'M',
    birthdate: null,
    address: '',
    city: defaultComboDataDTO,
    isCityExternalId: true,
    mobilephone: '',
    email: ''
}

export interface ProfessionalData {
    prefix: string,
    workenrollment: string,
    workenrollmenttype: ComboDataDTO | null,
    specialities: MedicalSpeciality[],
    secretaries: UserAllowedToPrescript[],
    concurrentlocations: boolean,
    receiveprescriptions: boolean,
    signaturedata: string
}

export const defaultProfessionalData: ProfessionalData = {
    prefix: '',
    workenrollment: '',
    workenrollmenttype: defaultComboDataDTO,
    specialities: [],
    secretaries: [],
    concurrentlocations: false,
    receiveprescriptions: false,
    signaturedata: ''
}
//PaymentMethodAccountDetail
export interface PaymentAccount {
    paymentaccount: number | null,
    paymentMethod: ComboDataDTO | null,
    accountId: string,
    description: string,
    delete: boolean,
    insert: boolean,
}

export const defaultPaymentAccount: PaymentAccount = {
    paymentaccount: null,
    paymentMethod: defaultComboDataDTO,
    accountId: '',
    description: '',
    delete: false,
    insert: false,
}
export interface InvoiceData {
    vatcustomercategory: ComboDataDTO | null,
    fiscalidtype: ComboDataDTO | null,
    fiscalid: string,
    businessname: string, //medereentity
    iibb: string,
    iibbperceptionagent: boolean, //buscar donde está
    fiscaladdress: string,
    afipalias, //TaxInfoBillingAgent
    companystartdate: Date | null,
    creditelectronic: boolean,
    invoicetype: ComboDataDTO | null,
    afipproductionmode: boolean,
    pos: ComboDataDTO | null,
    paymentmethod: ComboDataDTO | null,
    bankaccount: string,
    paymentaccounts: PaymentAccount[],
}

export const defaultInvoiceData: InvoiceData = {
    vatcustomercategory: defaultComboDataDTO,
    fiscalidtype: defaultComboDataDTO,
    fiscalid: '',
    businessname: '',
    iibb: '',
    iibbperceptionagent: false,
    fiscaladdress: '',
    afipalias: '',
    companystartdate: null,
    creditelectronic: false,
    invoicetype: defaultComboDataDTO,
    afipproductionmode: false,
    pos: defaultComboDataDTO,
    paymentmethod: defaultComboDataDTO,
    bankaccount: '',
    paymentaccounts: [],
}

export interface UserConfigData {
    username: string,
    password: string,
    confirmpassword: string,
}

export const defaultUserConfigData: UserConfigData = {
    username: '',
    password: '',
    confirmpassword: '',
}

export interface ProfileDataFormDTO {

    medereentityid: number,

    personalData: PersonalData,
    professionalData: ProfessionalData,
    invoiceData: InvoiceData,
    userConfigData: UserConfigData,

    isprofessional: boolean,
}

export const defaultProfileDataFormDTO: ProfileDataFormDTO = {
    medereentityid: -1,
    personalData: defaultPersonalData,
    professionalData: defaultProfessionalData,
    invoiceData: defaultInvoiceData,
    userConfigData: defaultUserConfigData,
    isprofessional: false,
}
